import Vue from 'vue';

//枚举下拉框
import SHEnumCombo from './combo/index.js'
Vue.use(SHEnumCombo);


//枚举复选框
import SHEnumCheckbox from './checkbox/index.js'
Vue.use(SHEnumCheckbox);

//枚举单选框
import SHEnumRadio from './radio/index.js'
Vue.use(SHEnumRadio);
//枚举名称展示
import SHEnumShow from './show/index.js'
Vue.use(SHEnumShow);



// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/cmps.js